<template>
	<div class="tl-task-list">
		<TLTaskListRow 
			v-for="schedule in schedules"
			:key="schedule.code"
			:schedule="schedule"
			:items="items"
			:selected_member_code="selected_member_code"
			v-bind:watchSlide="watchSlide"
			v-on:schedule-list-row-slide="onScheduleListRowSlide"
			v-on:show-project-task-list="onClickShowProjectTaskList"
			v-on:show-task-info="onClickShowTaskInfo"
		/>
	</div>
</template>
<script>
import TLTaskListRow from './TLTaskListRow';
export default {
	name: 'TLTaskList',
	props: [
		"items",
		"schedules",
		"selected_member_code",
	],
	components: {
		TLTaskListRow,
	},
	data () {
		return {
			watchSlide: null,
		}
	},
	methods: {
		onClick: function(e) {
			this.watchSlide = {
				type: 'click',
				target: e,
				status: null,
			};
		},
		onScheduleListRowSlide: function(e) {
			this.watchSlide = {
				type: 'slide',
				target: e.target,
				status: e.status,
			};
		},
		onClickShowProjectTaskList: function(e) {
			this.$emit('show-project-task-list', e);
		},
		onClickShowTaskInfo: function(e) {
			this.$emit('show-task-info', e);
		},
	},
	computed: {
	},
	mounted: function() {
		window.addEventListener('click', this.onClick, false);
	},
	beforeDestory: function() {
		window.removeEventListener('click', this.onClick, false);
	},
}
</script>
<style>
	.tl-task-list {
		flex: 0 0 100% !important;
		background-color: white;
	}
</style>
